import type { ApiErrorResponse } from '@calcom/atoms/dist/packages/platform/types/api';
import { context } from '@shared-services/context-service';
import { logger } from '@shared-services/log-service';
import { BookerContextType } from './types';

export const logBookingError = (
    message: string,
    additionalInfoToLog: Record<string, unknown>
) => {
    logger.error({
        message,
        tags: ['__new-runtime__', 'RuntimeCalBooking'],
        isEditor: context.isEditor,
        ...additionalInfoToLog,
    });
};

export const logBookingInfo = (
    message: string,
    additionalInfoToLog?: Record<string, unknown>
) => {
    logger.info({
        message,
        tags: ['__new-runtime__', 'RuntimeCalBooking'],
        isEditor: context.isEditor,
        ...additionalInfoToLog,
    });
};

export const createBookerResponseLoggingContext = (
    bookerContext: BookerContextType,
    res: ApiErrorResponse
) => ({
    errorMessage: res.error.message,
    errorCode: res.error.code,
    errorDetails: res.error.details,
    additionalInfoToLog: bookerContext,
});
